import has from 'lodash/has';

const toMedicalConditionMap = (value) => {
  if (!value || (typeof value === 'string' && value.trim() === '')) {
    return {};
  }
  if (typeof value === 'object') {
    return value;
  }
  return JSON.parse(value);
};

const buildStudentManagementConfigPayload = (
  vendorSid,
  moduleName,
  vendorName,
  serviceEnded,
  isVendorSelectionOnlyVendor,
  isFileVendor,
  studentManagementConfig = {},
  studentSelectionInRiskAssessmentEnabled = false
) => {
  if (!vendorSid) {
    return null;
  }

  if (isVendorSelectionOnlyVendor || isFileVendor) {
    return {
      studentVendorClientSid: vendorSid,
      moduleName,
      vendorName,
      isVendorServiceEnded: serviceEnded
    };
  }

  const config = {
    ...studentManagementConfig,
    studentSelectionInRiskAssessmentEnabled
  };

  if (has(studentManagementConfig, 'clientToStbMedicalConditionMap')) {
    config.clientToStbMedicalConditionMap = toMedicalConditionMap(
      studentManagementConfig.clientToStbMedicalConditionMap
    );
  }

  return {
    config,
    studentVendorClientSid: vendorSid,
    moduleName,
    vendorName,
    isVendorServiceEnded: serviceEnded
  };
};

export default buildStudentManagementConfigPayload;
